<template>
  <v-card :color="backColor" elevation=0 tile class="label d-flex pl-2">
    <span class="my-auto label-text"><slot></slot></span>
  </v-card>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#eceaea'
    },
    noColor: {
      type: Boolean,
      default: false
    },
    classes: {
      type: Array,
      default: null
    }
  },
  data: () => ({

  }),
  computed: {
    backColor () {
      return this.noColor ? '' : this.color
    }
  }
}
</script>

<style scoped>

.label {
  height: 100%;
  padding: 8px 0;
}
.label-text {
  width: 100%;
}
</style>
